import type { MouseEvent } from "react";
import { FormRow } from "@omnabase/ui";
import { HELP_CSS_MAX } from "@omnabase/shared";
import { useFormState } from "../../lib/save";

/** Settings › Projects › Help centre, the two customisations (2026-10-12, the docs-style help centre). The logo became the project's on
 *  2026-10-20: this tab names where it is set (the project's General tab) and links there; the company's own CSS stays, saved as you type and
 *  printed after our styles on every help page, for workspace administrators. */
export function HelpLogoLine({ generalHref, onOpen }: { generalHref: string; onOpen: (e: MouseEvent<HTMLAnchorElement>) => void }) {
  return <FormRow label="Logo" help="The header shows the project's logo, else the workspace's, else the title."><span className="ob-form-row__help">The project&apos;s logo, set under <a className="ob-link" href={generalHref} onClick={onOpen}>General</a></span></FormRow>;
}

export function HelpCssRow({ projectId, css, save }: { projectId: string; css: string | null; save: (patch: { customCss: string | null }) => void }) {
  const [text, setText] = useFormState(css ?? "", projectId);
  return (
    <FormRow label="Custom CSS" audience="admins" stack help="Added after our styles on every help page.">
      <textarea className="ob-css-field" value={text} aria-label="Custom CSS" spellCheck={false} maxLength={HELP_CSS_MAX} placeholder=".ob-help__brand { font-weight: 700; }" onChange={(e) => { setText(e.target.value); save({ customCss: e.target.value || null }); }} />
    </FormRow>
  );
}
